import React from "react";
import PropTypes from "prop-types";
import MainButton from "../../Elements/MainButton/MainButton";

import successIcon from "../../../assets/flash-message/success.png";
import errorIcon from "../../../assets/flash-message/exclamation.png";

import "./StatusModal.css";

const StatusModal = ({ isOpen, type = "success", isLoggedIn = false, onClose, customMessage }) => {
  if (!isOpen) return null;

  const isSuccess = type === "success";

  const handleOverlayClick = () => {
    if (isSuccess) {
      window.location.href = "/cart";
    } else {
      onClose();
    }
  };

  const handleSuccessPrimaryClick = () => {
    if (isLoggedIn) {
      window.location.href = "/esim";
    } else {
      window.location.href = "/shop";
    }
  };

  const handleCanceledPrimaryClick = () => {
    window.location.href = "/cart";
  };

  const message = isSuccess
    ? isLoggedIn
      ? "Your eSIM details and installation steps are available in the eSIM menu."
      : "Your eSIM and installation instructions will arrive in your email shortly."
    : customMessage || "Your cart is waiting. Try again anytime.";

  const successButtonLabel = isLoggedIn ? "See eSIMs" : "Continue Shopping";

  return (
    <div className="status-modal-overlay" onClick={handleOverlayClick}>
      <div className="status-modal" onClick={(e) => e.stopPropagation()}>
        <div className="status-modal-icon">
          <img src={isSuccess ? successIcon : errorIcon} alt={isSuccess ? "Success" : "Warning"} />
        </div>

        <h2 className={`status-modal-title ${isSuccess ? "success" : "canceled"}`}>
          {isSuccess ? "Payment Successful" : "Payment Canceled"}
        </h2>

        <p className="status-modal-message">{message}</p>

        <div className="status-modal-actions">
          {isSuccess ? (
            <MainButton onClick={handleSuccessPrimaryClick} className="status-btn">
              {successButtonLabel}
            </MainButton>
          ) : (
            <MainButton onClick={handleCanceledPrimaryClick} className="status-btn">
              Back to Cart
            </MainButton>
          )}
        </div>
      </div>
    </div>
  );
};

StatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.oneOf(["success", "canceled"]),
  isLoggedIn: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  customMessage: PropTypes.string,
};

export default StatusModal;
